<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-click="rowClick"
          @selection-change="handleSelectionChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="1200px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <div class="form-page-container" style="padding: 20px; height: 100%;">
          <el-form ref="dataForm" :model="temp" :rules="rules" label-width="120px" label-position="right"
            style="height: 100%; overflow: auto;">

            <el-tabs v-model="activeTab" type="card">
              <el-tab-pane label="基本信息" name="info">


                <el-input v-model="temp.id" size="small" disabled placeholder="主键 (ID)" type="hidden" />
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="营地名" prop="name">
                      <el-input v-model="temp.name" size="small" placeholder="请输入营地名" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="排序" prop="order">
                      <el-input v-model.number="temp.order" size="small" type="number" placeholder="请输入排序序号" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="城市" prop="cityCode" class="my-cascader-container">
                      <el-cascader v-model="temp.cityCode" :options="areaCities"
                        :props="{ value: 'id', label: 'name', children: 'children', emitPath: false }"></el-cascader>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="类型" prop="campType">
                      <el-select v-model="temp.campType" placeholder="请选择营地类型" size="small" style="width: 100%;">
                        <el-option v-for="(item,index) in campTypes" :key="index" :label="item" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="地址" prop="address">
                      <el-input v-model="temp.address" size="small" placeholder="请输入地址" />
                    </el-form-item>
                  </el-col>
                  
                  <el-col :span="12">
                    <el-form-item label="经度" prop="longitude">
                      <el-input v-model="temp.longitude" size="small" placeholder="请输入经度" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="纬度" prop="latitude">
                      <el-input v-model="temp.latitude" size="small" placeholder="请输入纬度" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="联系人" prop="contact">
                      <el-input v-model="temp.contact" size="small" placeholder="请输入联系人姓名" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="联系电话" prop="contactPhone">
                      <el-input v-model="temp.contactPhone" size="small" placeholder="请输入联系电话" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="是否已发布" prop="isPub">
                      <el-switch v-model="temp.isPub" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="发布时间" prop="pubDate">
                      <el-date-picker v-model="temp.pubDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择发布时间" size="small" style="width: 100%;" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="大群名" prop="bigChannelName">
                      <el-input v-model="temp.bigChannelName" size="small" placeholder="请输入大群名" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="大群Id" prop="bigChannelId">
                      <el-input v-model="temp.bigChannelId" size="small" placeholder="请输入大群ID" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="营地群名" prop="campChannelName">
                      <el-input v-model="temp.campChannelName" size="small" placeholder="请输入营地群名" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="营地群Id" prop="campChannelId">
                      <el-input v-model="temp.campChannelId" size="small" placeholder="请输入营地群ID" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="标题图" prop="headPic">
                      <el-upload class="headpic-uploader"
                        action="https://api.tl2001.tourling.com/api/client/uploadCampPic" :show-file-list="false"
                        :headers="{ 'X-Token': token }" v-model="temp.headPic"
                        :on-success="handlePicSuccess" :before-upload="beforePicUpload">
                        <img v-if="temp.headPic" :src="temp.headPic" class="headpic">
                        <i v-else class="el-icon-plus headpic-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>


                </el-row>
              </el-tab-pane>

              <el-tab-pane label="更多" name="more">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="摘要" prop="summary">
                      <el-input v-model="temp.summary" type="textarea" :rows="3" size="small" placeholder="请输入摘要内容" />
                    </el-form-item>
                  </el-col>

                  <el-col :span="24">
                    <el-form-item label="详情" prop="desc">
                      <div style="margin-top: 20px; height:700px;">
                        <WangEditorV5 v-model="temp.desc" :token="token"/>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>


        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import WangEditorV5 from '@/components/WangEditor/WangEditorV5.vue'
import * as camps from '@/api/camps'
import * as client from '@/api/client'
import { getToken } from '@/utils/auth'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'camp',
  components: { Sticky, permissionBtn, Pagination, AuthTable, WangEditorV5 },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      token:'',
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        key: undefined,
      },
      activeTab: 'info',
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      areaCities: [],
      campTypes: [],
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.token = getToken()
    this.headerList = [
      new ColumnDefine('name', '营地名', true, true, 'text', '', 'string', 'varchar', 'Name'),
      new ColumnDefine('contact', '联系人', true, true, 'text', '', 'string', 'varchar', 'Contact'),
      new ColumnDefine('contactPhone', '联系电话', true, true, 'text', '', 'string', 'varchar', 'ContactPhone'),
      new ColumnDefine('order', '排序', true, true, 'number', '', 'int', 'int', 'Order'),
      new ColumnDefine('isPub', '是否已发布', true, true, 'switch', '', 'bool', 'bit', 'IsPub'),
      new ColumnDefine('pubDate', '发布时间', true, true, 'datetime', '', 'DateTime', 'datetime', 'PubDate'),
      new ColumnDefine('campChannelName', '营地群名', true, true, 'text', '', 'string', 'varchar', 'CampChannelName'),
      new ColumnDefine('campChannelId', '营地群Id', true, true, 'text', '', 'string', 'varchar', 'CampChannelId'),
      new ColumnDefine('bigChannelName', '大群名', true, true, 'text', '', 'string', 'varchar', 'BigChannelName'),
      new ColumnDefine('bigChannelId', '大群Id', true, true, 'text', '', 'string', 'varchar', 'BigChannelId'),
      new ColumnDefine('fullAddress', '完整地址', false, false, 'text', '', 'string', 'varchar', 'FullAddress'),
      new ColumnDefine('id', '主键', true, true, '', '', 'number', 'bigint', 'Id'),
    ]
    this.getList()
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    handlePicSuccess(res){
      this.temp.headPic = res.result.filePath;
      console.log(this.temp);
    },
    beforePicUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const lsLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
      }
      if (!lsLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isJPG && lsLt10M
    },
    getList() {
      this.listLoading = true
      camps.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    getCampTypes() {
      client.getCampTypes().then((response) => {
        this.campTypes = response.result;
      })
    },
    getAreaCityTree() {
      if (!this.areaCities || this.areaCities.length == 0) {
        client.getAreaCityTree().then((response) => {
          this.areaCities = response.result
          this.areaCities.forEach(item => {
            delete item.parentId
            delete item.parentName
            if (item.children && item.children.length > 0) {
              item.children.forEach(child => {
                delete child.parentId
                delete child.parentName
                if (child.children && child.children.length > 0) {
                  child.children.forEach(grandson => {
                    delete grandson.parentId
                    delete grandson.parentName
                    if (!grandson.children || grandson.children.length == 0) {
                      delete grandson.children;
                    }
                  });
                } else {
                  delete child.children;
                }
              });
            } else {
              delete item.children;
            }
          });
        })
      }
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      this.getCampTypes();
      this.getAreaCityTree();
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate(() => {
        camps.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        camps.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(camps, rows)
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

.my-cascader-container:deep(.el-cascader-panel) {
  /* 设置面板整体宽度，例如 400px */
  width: 800px;
}

.headpic-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.headpic-uploader .el-upload:hover {
  border-color: #409EFF;
}

.headpic-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.headpic {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
